import script from "./DonationTabNotes.vue?vue&type=script&setup=true&lang=ts"
export * from "./DonationTabNotes.vue?vue&type=script&setup=true&lang=ts"

import "./DonationTabNotes.vue?vue&type=style&index=0&id=2dcd14ca&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dcd14ca"]])

export default __exports__